import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PersonActivitySearchSchema } from '@/routes/_staff/people/_list/operation-activity/-zod-schema';
export const Route = createFileRoute('/_staff/person/alumni/$id/_profile/operation-activity/')({
  validateSearch: zodValidator(PersonActivitySearchSchema)
});